import { BottomSummaryBarV2, SummaryColumn } from '@/components/custom/erp';

interface BottomBarProps {
  totals: {
    so_luong: number;
    thanh_tien: number;
  };
}

export const BottomBar = ({ totals }: BottomBarProps) => {
  const columns: SummaryColumn[] = [
    {
      className: 'min-w-[220px]',
      fields: [{ name: 't_so_luong', label: 'Tổng số lượng', value: totals.so_luong, precision: 6 }]
    },
    {
      className: 'min-w-[240px]',
      fields: [{ name: 't_tien', label: 'Tổng tiền', value: totals.thanh_tien, inputClassName: 'text-right' }]
    }
  ];

  return <BottomSummaryBarV2 columns={columns} />;
};

export default BottomBar;
